import { EXPERIMENT_CONFIG } from '../experiments';

export const isStaticExperiment = (experimentName: string) => {
  return Object.values(EXPERIMENT_CONFIG).includes(experimentName);
};
